export const sw = {
  "nav.check_booking": "Angalia Nafasi",
  "nav.admin": "Msimamizi",
  "nav.book_now": "Weka Nafasi Sasa",
  "nav.driver": "Dereva",
  "hero.badge": "Usafiri wa Wanafunzi wa Visa J1",
  "hero.title": "Usafiri Rahisi",
  "hero.subtitle": "Usafiri Wako wa Kuaminika kutoka Viwanja vya Ndege vya Chicago hadi Wisconsin",
  "hero.description": "Usafiri salama, wa kuaminika, na wa bei nafuu kwa wanafunzi wa visa J1. Weka nafasi ya kupandishwa uwanja wa ndege au safari ya kurudi leo!",
  "hero.book_trip": "Weka Nafasi ya Safari Yako",
  "hero.check_status": "Angalia Hali ya Nafasi",
  "pricing.title": "Bei za Usafiri",
  "pricing.subtitle": "Bei zote kwa Dola za Marekani",
  "pricing.ohare_mke": "Kupandisha (O'Hare / Milwaukee)",
  "pricing.midway": "Kupandisha (Midway)",
  "pricing.madison": "Madison hadi Wisconsin Dells",
  "pricing.return": "Punguzo la Kurudi",
  "pricing.shared": "Safari ya Pamoja",
  "pricing.private": "Safari ya Kibinafsi",
  "pricing.per_person": "kwa mtu",
  "pricing.after_deposit": "baada ya amana ya $20",
  "pricing.without_deposit": "bila amana",
  "pricing.flat_rate": "bei fasta",
  "pricing.per_suitcase": "Kwa sanduku",
  "pricing.carry_on": "Mzigo wa mkono",
  "pricing.free": "BURE",
  "pricing.with_shipping": "Kurudi + tuma nasi",
  "pricing.special_deal": "Ofa Maalum!",
  "pricing.midway_contact": "Wasiliana nasi kwa bei za Midway (MDW)",
  "pricing.waterpark_note": "Bei zinaweza kutofautiana kwa Three Bears Water Park au maeneo mengine.",
  "pricing.contact_us": "Wasiliana nasi",
  "pricing.guidelines_title": "Jinsi Bei Zetu Zinavyofanya Kazi",
  "pricing.guidelines_deposit": "Amana ya $20 kwa mtu inahakikisha nafasi yako. Salio linalobaki linatozwa siku ya safari.",
  "pricing.guidelines_shared": "Abiria 2 au zaidi wanaosafiri siku moja kwenda uwanja mmoja wa ndege wanapata bei ya safari ya pamoja.",
  "pricing.guidelines_solo": "Abiria wa peke yake (abiria pekee siku hiyo) anaweza kutozwa bei kidogo zaidi.",
  "pricing.guidelines_suitcase": "Sanduku 1 linajumuishwa bure kwa safari za kurudi. Kila sanduku la ziada ni $5.",
  "pricing.guidelines_payment": "Tunakubali malipo ya Kadi, Fedha Taslimu, na Zelle.",
  "requirements.title": "Masharti ya Kupata Nafasi",
  "requirements.pickup": "Tunatoa kupandisha mara mbili ndani ya masaa 24 isipokuwa umearifu vinginevyo. Panga mapema!",
  "requirements.deposit": "Amana isiyorudishwa ya $20 USD inahitajika kabla ya kuongezwa kwenye ratiba.",
  "requirements.seamless": "Hakikisha nafasi yako kwa kufanya amana mapema ili kuepuka ucheleweshaji wowote.",
  "requirements.final_payment": "Salio linalobaki linatozwa kabla ya kuingia garini.",
  "special.title": "Mahali Hapapo kwenye Orodha?",
  "special.description": "Tunatoa safari za ombi maalum kwenda maeneo yasiyo kwenye njia zetu za kawaida. Wasiliana nasi kwa bei maalum!",
  "special.call": "Piga Simu",
  "special.whatsapp": "WhatsApp Sisi",
  "features.title": "Kwa Nini Uchague Usafiri Rahisi?",
  "features.subtitle": "Kuaminiwa na maelfu ya wanafunzi wa J1 kila majira ya joto",
  "features.easy_booking": "Kupata Nafasi Rahisi",
  "features.easy_booking_desc": "Amana ya $20 USD tu inahitajika. Lipa kupitia uhamisho wa benki, kadi, PayPal, au Zelle.",
  "features.safe": "Salama na Kuaminika",
  "features.safe_desc": "Madereva wa kitaalamu, magari ya starehe, na msaada wa masaa 24/7 kwa wanafunzi wa J1.",
  "features.flexible": "Ratiba Inayobadilika",
  "features.flexible_desc": "Weka nafasi ya safari ya kuwasili na kurudi. Sanduku la kwanza bure kwa kurudi!",
  "video.badge": "Tuone Tukifanya Kazi",
  "video.title": "Safari Yako Inaanza Hapa",
  "video.subtitle": "Angalia wanafunzi wa J1 wakianza safari yao",
  "video.book_now": "Weka Nafasi ya Safari Yako Sasa",
  "booking.title": "Weka Nafasi ya Safari Yako",
  "booking.step": "Hatua",
  "booking.of": "ya",
  "booking.trip_type": "Aina ya Safari",
  "booking.arrival": "Kuwasili (Kupandishwa Uwanja wa Ndege)",
  "booking.return": "Kurudi (Kwenda Uwanja wa Ndege)",
  "booking.ride_type": "Aina ya Safari",
  "booking.shared_ride": "Safari ya Pamoja",
  "booking.shared_desc": "Shiriki na abiria wengine kwenye njia moja",
  "booking.private_ride": "Safari ya Kibinafsi",
  "booking.private_desc": "Gari la kipekee kwako tu",
  "booking.pickup_location": "Uwanja wa Ndege wa Kupandisha",
  "booking.select_airport": "Chagua Uwanja wa Ndege",
  "booking.travel_date": "Tarehe ya Kusafiri",
  "booking.travel_time": "Muda Unaotarajiwa wa Kuwasili",
  "booking.departure_time": "Muda wa Kuondoka",
  "booking.flight_number": "Nambari ya Ndege",
  "booking.airline": "Shirika la Ndege",
  "booking.terminal": "Terminali ya Kuwasili",
  "booking.full_name": "Jina Kamili",
  "booking.whatsapp": "Nambari ya WhatsApp",
  "booking.email": "Anwani ya Barua Pepe",
  "booking.housing": "Nyumba ya Makazi",
  "booking.select_housing": "Chagua Nyumba",
  "booking.custom_address": "Ingiza Anwani Maalum",
  "booking.num_passengers": "Idadi ya Abiria",
  "booking.suitcases": "Jumla ya Masanduku",
  "booking.shipping": "Unatumia Huduma za T&M Courier?",
  "booking.payment": "Njia ya Malipo",
  "booking.referral": "Msimbo wa Rufaa",
  "booking.next": "Ifuatayo",
  "booking.previous": "Iliyotangulia",
  "booking.submit": "Kamilisha Nafasi",
  "booking.processing": "Inashughulika...",
  "booking.start_over": "Anza Upya",
  "booking.first_time": "Safari ya Kwanza",
  "booking.returning": "Mteja Anayerudi",
  "booking.confirmation_number": "Nambari ya Uthibitisho",
  "pricing_summary.title": "Muhtasari wa Bei",
  "pricing_summary.trip_price": "Bei ya Safari",
  "pricing_summary.luggage_fee": "Ada ya Mizigo",
  "pricing_summary.deposit": "Amana",
  "pricing_summary.per_person": "kwa mtu",
  "pricing_summary.discount": "Punguzo la Rufaa",
  "pricing_summary.total_now": "Jumla ya Sasa",
  "pricing_summary.balance": "Salio Linalobaki",
  "success.title": "Nafasi Imethibitishwa!",
  "success.confirmation": "Nambari ya Uthibitisho",
  "success.details": "Maelezo ya Nafasi",
  "success.whatsapp_optin": "Pata sasisho kupitia WhatsApp",
  "success.home": "Rudi Nyumbani",
  "driver.title": "Dashibodi ya Dereva",
  "driver.login": "Ingia kama Dereva",
  "driver.phone": "Nambari ya Simu",
  "driver.pin": "Msimbo wa PIN",
  "driver.sign_in": "Ingia",
  "driver.trips_today": "Safari za Leo",
  "driver.upcoming": "Safari Zijazo",
  "driver.passengers": "abiria",
  "driver.suitcases": "masanduku",
  "driver.navigate": "Elekeza Kupandisha",
  "driver.contact": "Wasiliana na Abiria",
  "driver.complete": "Kamilisha Safari",
  "driver.logout": "Ondoka",
  "driver.no_trips": "Hakuna safari zilizopangwa",
  "common.loading": "Inapakia...",
  "common.error": "Kitu kimekwenda vibaya",
  "common.save": "Hifadhi",
  "common.cancel": "Ghairi",
  "common.close": "Funga",
  "common.details": "Maelezo",
  "common.status": "Hali",
  "common.date": "Tarehe",
  "common.time": "Muda",
  "common.price": "Bei",
  "common.passenger": "Abiria",
  "common.passengers": "Abiria",
};
